import { common } from '@mui/material/colors'
import { createTheme } from '@mui/material/styles'

export const pipelineColor = '#105294'
export const primaryColor = '#009688'
export const primaryColorOpacity = '#0096881A'
export const secondaryColor = '#F2A86D'
export const secondaryColorOpacity = '#F2A86D1A'
export const secondaryColorBright = '#F4AC0E'
export const secondaryColorBrightOpacity = '#F2A86DE6'

export const mui5Breakpoints = {
    values: {
        // MUI5 Defaults
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1400,
        xl: 1536,

        // MUI4 Defaults
        // xs: 0,
        // sm: 600,
        // md: 960,
        // lg: 1280,
        // xl: 1920,
    },
}

export const mui4Breakpoints = {
    values: {
        // MUI4 Defaults
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1400,
        xl: 1920,
    },
}

export const breakpoints = mui5Breakpoints

const tempTheme = createTheme({ breakpoints })

export const palette = {
    text: {
        primary: '#303030',
        secondary: '#616161',
    },
    primary: {
        main: '#009688',
        light: '#B2DFDB',
        dark: '#004D40',
        contrastText: '#fff',
    },
    secondary: {
        main: '#F2A86D',
        dark: '#EE5B12',
        light: '#FDE5B2',
        contrastText: '#000',
    },
    status: {
        success: '#009688',
        error: '#B00020',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    common,
}

export const typography = {
    h1: {
        fontWeight: 200,
        letterSpacing: -1.5,
        fontSize: 96,
        [tempTheme.breakpoints.down('sm')]: {
            fontSize: 60,
        },
    },
    h2: {
        fontWeight: 200,
        letterSpacing: -0.5,
        fontSize: 60,
        [tempTheme.breakpoints.down('sm')]: {
            fontSize: 48,
        },
    },
    h3: {
        fontWeight: 400,
        letterSpacing: 0,
        fontSize: 48,
        [tempTheme.breakpoints.down('sm')]: {
            fontSize: 34,
        },
    },
    h4: {
        fontWeight: 500,
        letterSpacing: 0.25,
        fontSize: 34,
        [tempTheme.breakpoints.down('sm')]: {
            fontSize: 28,
        },
    },
    h5: {
        fontWeight: 500,
        letterSpacing: 0,
        fontSize: 24,
        [tempTheme.breakpoints.down('sm')]: {
            fontSize: 20,
        },
    },
    h6: {
        fontWeight: 500,
        letterSpacing: 0.25,
        fontSize: 20,
        [tempTheme.breakpoints.down('sm')]: {
            fontSize: 17,
        },
    },
    body1: {
        fontWeight: 400,
        fontSize: 16,
        color: '#666666',
        letterSpacing: 0.5,
        [tempTheme.breakpoints.down('xs')]: {
            fontSize: 14,
            fontWeight: 500,
        },
    },
    body2: {
        fontWeight: 600,
        color: '#666666',
        fontSize: 14,
        letterSpacing: 0.25,
    },
    subtitle1: {
        fontWeight: 400,
        color: '#666666',
        fontSize: 16,
        letterSpacing: 0.15,
        [tempTheme.breakpoints.down('xs')]: {
            fontSize: 14,
        },
    },
    subtitle2: {
        fontWeight: 500,
        color: '#666666',
        fontSize: 14,
        letterSpacing: 0.1,
    },
    button: {
        fontWeight: 500,
        color: '#575757',
        fontSize: 14,
        letterSpacing: 1.25,
        [tempTheme.breakpoints.down('xs')]: {
            fontSize: 10,
        },
    },
    caption: {
        fontWeight: 400,
        color: '#9E9E9E',
        fontSize: 12,
        letterSpacing: 0.4,
    },
    overline: {
        fontWeight: 500,
        color: '#666666',
        fontSize: 12,
        letterSpacing: 2,
    },
}

export const colors = {
    pipelineColor: '#105294',
    primaryColor: '#009688',
    primaryColorOpacity: '#0096881A',
    secondaryColor: '#F2A86D',
    secondaryColorOpacity: '#F2A86D1A',
}

export const muiThemeBase = {
    palette,
    typography,
    breakpoints,
}

export const defaultMuiTheme = createTheme(muiThemeBase)

export type { Theme } from '@mui/material'
